<div class="order-container bg-blue mb-5">
    <div class="pt-4">
        <div class="breadcrumbs"><span class="order-breadcrumb"><a routerLink="/dashboard/orders">{{'order.orderDetails'
                    | translate }}</a></span> >
            <strong>{{dataComponent && dataComponent.data.code}}</strong>
        </div>
        <apc-section-anchors [sections]="sections"></apc-section-anchors>
    </div>
    <div id="nejo-order-data" class="pt-3">
        <nejo-order-data *checkPermission="{ role: 'viewer'}" [budgets]="budgetComponent?.forms"></nejo-order-data>
    </div>
    <div id="product" class="my-5">
        <nejo-order-products *checkPermission="{ role: 'viewer'}"></nejo-order-products>
    </div>
     <div id="budget" class="my-5">
        <njo-order-budget [orderName]="dataComponent?.data?.name"></njo-order-budget>
    </div>
</div>

<apc-create-element-buttons [buttons]="buttons" (createEvent)="createElement($event)"></apc-create-element-buttons>